<form nz-form [formGroup]="form" (ngSubmit)="submit()" role="form">
  <nz-tabset [nzAnimated]="false">
    <nz-tab [nzTitle]="'app.login.forgot-password' | i18n">
      <nz-alert
        *ngIf="error"
        [nzType]="'error'"
        [nzMessage]="error"
        [nzShowIcon]="true"
        class="mb-lg"
      />
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'validation.password.required' | i18n">
          <nz-input-group
            nzSize="large"
            nzAddonBeforeIcon="lock"
            nz-popover
            nzPopoverPlacement="right"
            nzPopoverTrigger="focus"
            [(nzPopoverVisible)]="visible"
            nzPopoverOverlayClassName="register-password-cdk"
            [nzPopoverOverlayStyle]="{ 'width.px': 240 }"
            [nzPopoverContent]="pwdCdkTpl"
          >
            <input
              nz-input
              type="password"
              formControlName="password"
              [placeholder]="'app.reset.password.placeholder' | i18n"
            />
          </nz-input-group>
          <ng-template #pwdCdkTpl>
            <div style="padding: 4px 0">
              <ng-container [ngSwitch]="status">
                <div *ngSwitchCase="'ok'" class="success">
                  {{ 'validation.password.strength.strong' | i18n }}
                </div>
                <div *ngSwitchCase="'pass'" class="warning">
                  {{ 'validation.password.strength.medium' | i18n }}
                </div>
                <div *ngSwitchDefault class="error">
                  {{ 'validation.password.strength.short' | i18n }}
                </div>
              </ng-container>
              <div class="progress-{{ status }}">
                <nz-progress
                  [nzPercent]="progress"
                  [nzStatus]="passwordProgressMap[status]"
                  [nzStrokeWidth]="6"
                  [nzShowInfo]="false"
                />
              </div>
              <p class="mt-sm">{{ 'validation.password.strength.msg' | i18n }}</p>
            </div>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control [nzErrorTip]="confirmErrorTip">
          <nz-input-group nzSize="large" nzAddonBeforeIcon="lock">
            <input
              nz-input
              type="password"
              formControlName="confirm"
              [placeholder]="'app.reset.confirm-password.placeholder' | i18n"
            />
          </nz-input-group>
          <ng-template #confirmErrorTip let-i>
            <ng-container *ngIf="i.errors?.required">
              {{ 'validation.confirm-password.required' | i18n }}
            </ng-container>
            <ng-container *ngIf="i.errors?.matchControl">
              {{ 'validation.password.twice' | i18n }}
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control [nzErrorTip]="mobileErrorTip">
          <nz-input-group nzSize="large" [nzAddOnBefore]="addOnBeforeTemplate">
            <ng-template #addOnBeforeTemplate>
              <nz-select formControlName="mobilePrefix" style="width: 100px">
                <nz-option [nzLabel]="'+86'" [nzValue]="'+86'" />
              </nz-select>
            </ng-template>
            <input
              formControlName="mobile"
              nz-input
              [placeholder]="'app.login.phone-number.placeholder' | i18n"
            />
          </nz-input-group>
          <ng-template #mobileErrorTip let-i>
            <ng-container *ngIf="i.errors?.required">
              {{ 'validation.phone-number.required' | i18n }}
            </ng-container>
            <ng-container *ngIf="i.errors?.pattern">
              {{ 'validation.phone-number.wrong-format' | i18n }}
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'validation.verification-code.required' | i18n">
          <nz-row [nzGutter]="8">
            <nz-col [nzSpan]="16">
              <nz-input-group nzSize="large" nzAddonBeforeIcon="mail">
                <input
                  nz-input
                  formControlName="captcha"
                  [placeholder]="'app.login.verification-code.placeholder' | i18n"
                  maxlength="4"
                />
              </nz-input-group>
            </nz-col>
            <nz-col [nzSpan]="8">
              <button
                type="button"
                nz-button
                nzSize="large"
                (click)="getCaptcha()"
                [disabled]="count > 0"
                nzBlock
                [nzLoading]="loading"
              >
                {{ count ? count + 's' : ('app.register.get-verification-code' | i18n) }}
              </button>
            </nz-col>
          </nz-row>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item>
        <button
          nz-button
          nzType="primary"
          nzSize="large"
          type="submit"
          [nzLoading]="loading"
          class="submit"
        >
          {{ 'app.reset.confirm' | i18n }}
        </button>
        <a class="login" routerLink="/passport/login">< {{ 'app.reset.back' | i18n }}</a>
      </nz-form-item>
    </nz-tab>
  </nz-tabset>
</form>
